import * as React from 'react';
import PieChart from 'react-minimal-pie-chart';
import styled from 'styled-components';
import { Body2 } from '@estee/elc-typography';
import { ContentSpacing } from '@estee/elc-base-theme';
import { classes } from '../../utils/Classes';
import { IShade } from '../../interfaces/IVto';
import { PIE_CHART_DEFAULT_VALUE } from '../../constants/Vto';

export interface IVtoShadeName {
    selectedShade: IShade;
}

const ShadeNameContainer = styled.div`
    display: flex;
    align-items: center;
`;

const ShadePieChart = styled.div`
    width: 15px;
    height: 15px;
    margin-right: ${ContentSpacing.space6};
    align-self: flex-start;
    flex-shrink: 0;
    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space6};
    }
`;

const shadeNameContainerClassNames = classes('vto-shade-name-container');
const shadePieChartClassNames = classes('vto-shade-pie-chart');
const shadeClassNames = classes('vto-shade-name');

export const VtoShadeName = (props: IVtoShadeName) => {
    const {
        selectedShade: { colors, hexVal, name }
    } = props;
    const pieChartData = colors.length
        ? colors.map((color) => ({ value: PIE_CHART_DEFAULT_VALUE, color }))
        : [{ value: PIE_CHART_DEFAULT_VALUE, color: hexVal }];

    return (
        <ShadeNameContainer className={shadeNameContainerClassNames}>
            <ShadePieChart className={shadePieChartClassNames}>
                <PieChart data={pieChartData} />
            </ShadePieChart>
            <Body2 className={shadeClassNames}>{name}</Body2>
        </ShadeNameContainer>
    );
};
